import React, { useRef, useState } from "react";
import {
  TrashIcon,
  EllipsisHorizontalCircleIcon,
  XCircleIcon,
  CheckCircleIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/solid";
import { getCurrencyAndLanguageSymbol } from "../../../../constent/currencyUtils";
import Whatsapp from "../../../../assets/Icons/icons8-whatsapp (1).svg";
import InvoiceIcon from "../../../sharedComponents/InvoiceIcon";

const DetailsCartRow = ({ details, onDelete, onEdit, onDetails, pdf }) => {
  const timeLeft = new Date(details.timeLeft);
  const now = new Date();
  const diff = timeLeft - now;
  const currencySymbol = getCurrencyAndLanguageSymbol();

  let remainingTime = "Time Finish";
  if (diff > 0) {
    const seconds = Math.floor((diff / 1000) % 60);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));

    remainingTime = ` ${hours}: ${minutes}: ${seconds}`;
  }
  const roundToTwo = (num) => parseFloat(Number(num).toFixed(2));
  const matchedArea =
    details?.area?._id === "67dfef4a100f542a2c700c04" ? "Turkey" : "Europe";

  const [showValue, setShowValue] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  const toggleValue = () => {
    setShowValue((prev) => !prev);
  };

  const values = [
    details.number,
    details.boxNumber,
    details.img,
    details.Name,
    details.phone,
    details.status,
    matchedArea,
    // details.note,
    details.isCheck,
    details.history ? new Date(details.history).toISOString().slice(5, 10) : "",

    roundToTwo(Number(details.totalCartPrice)),
    roundToTwo(Number(details.totalWeight)),
    roundToTwo(Number(details.totalPackingFees)),
    roundToTwo(Number(details.totalWeightAfterPacking)),
  ];

  // console.log(details.isOutCart)
  return (
    <tr
      className={`text-sm text-center text-gray-800 ${
        details.isReadyToPaid
          ? "bg-white"
          : details.isOutCart && details.isPacking
          ? "bg-[#1FD224] text-white"
          : details.status === "outCart"
          ? "bg-[#FF8A1B] text-white"
          : details.isPacking
          ? "bg-[#1FD224] text-white"
          : "bg-white"
      } `}
    >
      {values.map((value, index) => (
        <td
          key={index}
          className={
            index === 0
              ? `border-e-2 border-gray-200 ${
                  details.isOutCart && details.isPacking
                    ? "text-white p-2 bg-[linear-gradient(to_left,_#1FD224_50%,_#FF8A1B_50%)]"
                    : details.isOutCart
                    ? "bg-[#FF8A1B] text-white"
                    : details.isPacking && !details.isOutCart
                    ? "bg-[#1FD224] text-white"
                    : "bg-white"
                }`
              : "px-2 py-2"
          }
        >
          {index === 2 && details.isPacking ? (
            <span className="text-black cursor-pointer">
              <img src={value} alt="Product" className="w-10" />
            </span>
          ) : index === 2 && !details.isPacking ? null : index === 4 ? (
            <span className="flex items-center justify-center gap-2 text-black test-sm">
              {details.countryCode + value}
              <a href={`tel:${details.countryCode + value}`} className="">
                <img src={Whatsapp} className="w-7" />
              </a>
            </span>
          ) : index === 100 ? (
            <>
              <div className="relative inline-block ">
                <span
                  onClick={toggleValue}
                  ref={buttonRef}
                  className="flex px-2 py-2 text-xs text-black cursor-pointer bg-custom-yellow"
                >
                  Show Info
                </span>

                {showValue && value && (
                  <div
                    className="absolute z-50 w-[500px] px-2 py-1 mt-2 text-sm bg-white border rounded shadow "
                    ref={dropdownRef}
                  >
                    {value}
                  </div>
                )}
              </div>
            </>
          ) : index === 7 ? (
            <span title={value} className="flex justify-center text-black">
              {value ? (
                <CheckCircleIcon class="h-6 w-6 text-blue-600" />
              ) : (
                <XCircleIcon class="h-6 w-6 text-red-600" />
              )}
            </span>
          ) : index === 8 && details.history ? (
            <div className="flex flex-col">
              <span className="text-black">
                {new Date(details.history).toISOString().slice(5, 10)}
              </span>
              <span className="text-black">
                {new Date(details.history).toLocaleTimeString("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                  timeZone: "Asia/Kuwait",
                })}
              </span>
            </div>
          ) : index === 9 || index === 11 ? (
            <>
              <span className="text-black">
                {value}{" "}
                <span className="text-[9px] text-black"> {currencySymbol}</span>
              </span>
            </>
          ) : index === 10 || index === 12 ? (
            <>
              <span className="text-black ">
                {value} <span className="text-[9px] text-black"> KG</span>
              </span>
            </>
          ) : (
            value
          )}
        </td>
      ))}
      <td className="px-2 py-2">
        <div className="flex justify-around space-x-2">
          {!details.isOutCart ? (
            <button onClick={() => window.open(`${pdf}`, "_blank")}>
              <InvoiceIcon bgColor={"black"} />
            </button>
          ) : (
            <div className="w-6 ms-2"></div>
          )}
          {details.isPacking ? (
            <button onClick={onEdit}>
              <PencilSquareIcon className="w-5 h-5 text-black" />
            </button>
          ) : (
            <div className="w-6 ms-2"></div>
          )}
          <button onClick={onDelete} className="">
            <TrashIcon className="w-5 h-5 text-red-600" />
          </button>
        </div>
      </td>
      <td className="px-2 py-2">
        <div className="flex space-x-2">
          <button onClick={onDetails}>
            <EllipsisHorizontalCircleIcon className="bg-black rounded-full text-custom-yellow w-7" />
          </button>
        </div>
      </td>
    </tr>
  );
};

export default DetailsCartRow;
